var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.925 67.376 0 52.526 45.615 0l6.924 14.851L6.925 67.376z",
    fill: "#3DD9B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.37 19.95-15.83-5.097L45.575.036 59.9 6.38l8.471 13.57z",
    fill: "#19AA86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.382 99.999-15.873-5.044L84.13 42.44 100 47.484 54.382 99.999z",
    fill: "#3DD9B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.958 47.53-15.832-5.098-6.964-14.817 14.323 6.344 8.473 13.57z",
    fill: "#19AA86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.58 80.104 6.923 14.85 45.62-52.514-6.924-14.85-20.197 23.25-8.793-7.684 20.2-23.253-15.872-5.044-45.62 52.515 15.872 5.044 15.754-18.132 8.792 7.682L31.58 80.104z",
    fill: "#1C4B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.966 38.858-4.816 5.52 8.776 7.696 4.816-5.52-8.776-7.697z",
    fill: "#19AA86"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h100v100H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.e71e5874f5c5b6bf87f8826fe4845237.svg";
export { ForwardRef as ReactComponent };